import { PageTitle } from "../components/PageTitle";

const ReturnPolicy = () => {
  return (
    <>
      <PageTitle
        title="Return & Refund Policy"
        subtitle="No Worries, We've Got You!"
        bgImage="default.png"
      />

      <section className="flat-spacing-25">
        <div className="container">
          <div className="tf-main-area-page">
            <h4>HueHoppers Return &amp; Refund Policy</h4>
            <p>
              At HueHoppers, every order is created with love and color — and we
              want you to love what you receive just as much. If something isn't
              right, we're here to make it better. 🌈
            </p>

            <br />
            <h5>1.1 What's your return policy?</h5>
            <p>
              Returns and exchanges accepted within 14 days of delivery. Reverse
              pickup charges of ₹99 apply.
            </p>

            <h5>1.2 What are the eligibility conditions?</h5>
            <p>
              Items must be unused, unwashed, unworn — original tags and
              packaging intact. Items failing these conditions will not be
              accepted.
            </p>

            <h5>1.3 How do I initiate a return or exchange?</h5>
            <p>
              Initiate directly from your order page. Select items and schedule
              your pickup. Only one pickup attempt provided — not guaranteed.
            </p>

            <h5>1.4 Pickup failed. What next?</h5>
            <p>
              If pickup fails, you'll need to send the package back yourself.
            </p>

            <h5>1.5 Received something wrong or damaged?</h5>
            <p>
              Contact us within 48 hours of delivery with clear photos and your
              order ID at hello@huehoppers.com. Once verified, we'll resolve it
              immediately.
            </p>
            <h5>1.6 Can sale or discounted items be returned?</h5>
            <p>
              No. Items bought on sale, clearance, or marked "For Sale" are
              eligible for exchange only. No returns or refunds on discounted
              items.
            </p>
            <h5>1.7 How many exchanges can I make?</h5>
            <p>
              One exchange per order only. Once exchanged, the order becomes
              non-returnable.
            </p>
            <h5>1.8 Can store credit be used everywhere?</h5>
            <p>
              Store credit is valid for one year, applicable only on full-priced
              products. Not valid on sale, clearance, or discounted items — and
              can't be refunded for cash.
            </p>
            <h5>1.9 What happens to my discount if I return?</h5>
            <p>
              Any discounts or free shipping availed on the original order will
              be deducted from your refund amount.
            </p>
            <h5>1.10 What items cannot be returned or exchanged?</h5>
            <p>
              Free gifts. Used, washed, or altered products. Items without
              original tags or packaging. Requests raised after 14 days of
              delivery. Sale items — exchange only.
            </p>
            <h5>1.11 What if my item goes out of stock?</h5>
            <p>
              If your ordered item becomes unavailable, we'll inform you and
              refund to your original payment method.
            </p>
            <h5>1.12 Important</h5>
            <p>
              HueHoppers reserves the right to refuse requests not meeting
              policy conditions. Policy terms may be updated — latest version
              always available on our website.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default ReturnPolicy;
